﻿import { upOrDownOnScrollWheel } from "./HelperFunctions";

export function scrollHandler($: JQueryStatic): void {
    const body = document.querySelector("body");

    if (!body) return;

    if (body.classList.contains("post-results")) {
        const postFilters: HTMLElement | null = document.querySelector(
            ".post-results__filters-container"
        );
        if (postFilters) {
            upOrDownOnScrollWheel(postFilters);
        }
    }
    if (body.classList.contains("job-results")) {
        const jobFilters: HTMLElement | null = document.querySelector(
            ".job-results__filters-container"
        );

        if (jobFilters) {
            upOrDownOnScrollWheel(jobFilters);
        }
    }
}
